import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ReferenceRateValue } from 'src/features/referenceRateValues/utils/types';

const RESOURCE = '/subscriptions/reference-rate/:referenceRateId/reference-rate-value/:valueId/';

type QueryFnType = typeof queryFn;

interface DTO {
    referenceRateId: string;
    valueId: string;
}
const queryFn = ({ referenceRateId, valueId }: DTO): Promise<ReferenceRateValue> => {
    return axios.get(formatResourcePath(RESOURCE, { referenceRateId, valueId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetReferenceRateValue, RESOURCE as REFERENCE_RATE_VALUE_RESOURCE };
